import { RootState } from '@src/reducers';
import { Actions } from '@src/constants/Constants';

export namespace PreloaderActions {
    import PRELOADER_IS_VISIBLE = Actions.PRELOADER_IS_VISIBLE;

    export function isVisible(visible: boolean) {
        return async (dispatch: any, getState: () => RootState) => {
            dispatch({ type: PRELOADER_IS_VISIBLE, payload: visible });
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/PreloaderActions.ts